import {SaleStatus} from "./SaleStatus";

export const SaleStatusNames: Record<SaleStatus, string> = {
  [SaleStatus.BILLED]: "Facturada",
  [SaleStatus.PENDING_COLLECTION]: "Pendiente de Cobro",
  [SaleStatus.CASHED]: "Cobrada",
  [SaleStatus.CASHED_IN_PROGRESS]: "En Proceso de Cobro"
};
